import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import {
  Box,
  CircularProgress,
  Container,
  Toolbar,
  useMediaQuery,
  useTheme,
  // useMediaQuery,
} from '@mui/material'

//import { useTheme } from '@mui/material/styles'
import useConfig from 'hooks/useConfig'
import Drawer from './Drawer'
import Header from './Header'
import PaymentBanner from './Header/PaymentBanner'
import { SampleDataAlert } from './Header/SampleData/Alert'

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme()

  const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'))

  const { workspace, container, miniDrawer, drawerOpen, onChangeDrawerOpen } =
    useConfig()

  // drawer toggler
  const [open, setOpen] = useState(!miniDrawer || drawerOpen)
  const handleDrawerToggle = () => {
    setOpen(!open)
    onChangeDrawerOpen(!open)
  }

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      setOpen(!matchDownLG)
      onChangeDrawerOpen(!matchDownLG)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG])

  return (
    <Box
      sx={{ display: 'flex', width: '100%' }}
      key={workspace}>
      <Header
        open={open}
        handleDrawerToggle={handleDrawerToggle}
      />
      <Drawer
        open={open}
        handleDrawerToggle={handleDrawerToggle}
      />

      <Box
        component="main"
        sx={{ width: 'calc(100% - 278px)', flexGrow: 1 }}>
        <Box sx={{ p: 1 }}>
          <Toolbar />
          {container && (
            <Container
              maxWidth={false}
              sx={{
                marginLeft: 0,
                px: { xs: 0, sm: 2 },
                py: 3,
                position: 'relative',
                minHeight: 'calc(100vh - 110px)',
                display: 'flex',
                flexDirection: 'column',
                maxWidth: drawerOpen ? '1440px' : '1660px',
              }}>
              <SampleDataAlert />
              {workspace ? (
                <Outlet />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
                  <CircularProgress />
                </Box>
              )}
            </Container>
          )}
          {!container && (
            <Box
              sx={{
                position: 'relative',
                minHeight: 'calc(100vh - 110px)',
                display: 'flex',
                flexDirection: 'column',
              }}>
              {workspace ? (
                <Outlet />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
                  <CircularProgress />
                </Box>
              )}
            </Box>
          )}
        </Box>
        <div style={{ position: 'sticky', bottom: 0 }}>
          {workspace && <PaymentBanner />}
        </div>
      </Box>
    </Box>
  )
}

export default MainLayout
